import axios from "axios";

export const fetchLeaderboardData =
  (token, filter, leaderboard, timeData, subFilterData = null) =>
  async (dispatch) => {
    dispatch({ type: "FETCH_LEADERBOARD_USER_REQUEST" });
    const month =
      timeData?.month && timeData?.month !== "default" ? timeData?.month : "";
    const year =
      timeData?.year && timeData?.year !== "default" ? timeData?.year : "";
    // const year = timeData?.year || "";
    const leaderboardType = leaderboard || "monthly";

    let filter_sub = "";
    let filter_sub_c = "";
    if (subFilterData?.subFilter) {
      filter_sub = subFilterData.subFilter;
    }
    if (subFilterData?.childFilter) {
      filter_sub_c = subFilterData.childFilter;
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_USER}/getLeaderboard?filter=${filter}&leaderboard=${leaderboardType}&month=${month}&year=${year}&filter_sub=${filter_sub}&filter_sub_c=${filter_sub_c}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // "";
      if (response?.data?.success) {
        dispatch({
          type: "FETCH_LEADERBOARD_USER_SUCCESS",
          payload: response.data,
        });
      } else {
        dispatch({
          type: "FETCH_LEADERBOARD_USER_FAILURE",
          payload: response.data.message,
        });
      }
    } catch (error) {
      dispatch({
        type: "FETCH_LEADERBOARD_USER_FAILURE",
        payload: error.message,
      });
    }
  };
